import React from 'react';
import { useTranslation } from 'react-i18next';


/**
 * Footer component
 * @param {Object} props - Component props
 * @param {boolean} [props.islogin=false] - If true, show the login version of the footer
 * @returns {ReactElement} The footer component
 * @author  lionel ghogue ngondeke <lionelladrog@gmail.com> 2024/05/12
 */
export default function Footer(props) {

    const {t} = useTranslation();
    let date = new Date().toLocaleDateString(undefined, { year: 'numeric' });
    let footerClass = props.islogin ? " footer-login " : " footer-logout ";
   
    return (
        <footer>
            <div className={" container-fuild  text-center  footer-block " + footerClass} id="">
                <div className="">
                    <div>
                        <h6 className="text-upperccase "><a href='https://www.beachcomber-hotels.com/en/privacy-policy' target='_blank' rel="noreferrer">{t('conditionOfUse')}</a> </h6>
                        <p className="text-smaller text-capitalize">&#169; {date} New Mauritius Hotels Ltd</p>
                    </div>
                </div>

            </div>
        </footer>
    );

}

